export function localeString({
  value,
  locale = 'zh-CN',
  currency = 'CNY',
  showCurrency = false,
  showUnit = false,
} = {}) {
  if (value === null) {
    return null;
  }
  const val = Number(value) || 0;
  if (showUnit) {
    if (Math.abs(val) >= 1000000) {
      const w = val / 10000;
      return (Number.isInteger(w) ? w : w.toFixed(2)) + 'w';
    }
  }
  return val.toLocaleString(locale, { currency, style: showCurrency ? 'currency' : undefined });
}

export default {
  functional: true,
  render(h, { props: { value, color, locale = 'zh-CN', currency = 'CNY', showCurrency = false, showUnit = false } }) {
    return <span style={{ color }}>{ localeString({ value, locale, currency, showCurrency, showUnit }) }</span>;
  }
}
